import { render, staticRenderFns } from "@/style-guide/partials/expansion-panel/expansion-panel.pug?vue&type=template&id=14627587&scoped=true&lang=pug&external"
import script from "./expansion-panel.vue?vue&type=script&lang=ts"
export * from "./expansion-panel.vue?vue&type=script&lang=ts"
import style0 from "./expansion-panel.vue?vue&type=style&index=0&id=14627587&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14627587",
  null
  
)

export default component.exports